import g1 from "./Asset/1g.jpg"
import g2 from "./Asset/2g.jpg"
import g3 from "./Asset/3g.jpg"
import g4 from "./Asset/4g.jpg"
import g5 from "./Asset/5g.jpg"
import g6 from "./Asset/6g.jpg"
import g7 from "./Asset/7g.jpg"
import g8 from "./Asset/7g.jpg"


export default function ImageGallery() {
    const images = [
    g1,
    g2,
    g3,
    g4,
    g5,
    g6,
    g7,
    // g8,

    ];
  
    return (
      <div className=" flex flex-col items-center p-8 pt-5">
        <h1 className="text-3xl font-bold text-gray-800 dark:text-white mb-6">Gallery</h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
          {images.map((src, index) => (
            <div key={index} className="overflow-hidden rounded-2xl shadow-lg transition-transform transform hover:scale-105">
              <img src={src} alt={`Gallery Image ${index + 1}`} className="w-full object-cover" />
            </div>
          ))}
        </div>
      </div>
    );
  }
  